<template>
  <div id="app">
    <Nav></Nav>
    <router-view></router-view>
    <!-- <Home/> -->
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin

import Nav    from './components/global/Nav'
//import Home   from './components/homepage/MainHome'
import Footer from './components/global/Footer'
export default {
  name: 'App',
  components: {
    Nav,
    Footer,

  },
}
</script>
